import Vue from 'vue';
import axios from 'axios';
import store from './store';
import { VueEasyJwt } from 'vue-easy-jwt';
import { baseApiUrl, exibirErroTratado } from './global';

Vue.use({
  install(Vue) {
    // Cria a propriedade $http para ser acessada de forma global e atribui o axios a ela
    Vue.prototype.$http = axios;

    // Cria o interceptor de requisição
    Vue.prototype.$http.interceptors.request.use(
      async function(config) {
        // Caso não ocorreu na requisição continua o processamento
        store.commit('setLoader', true);
        
        if (store.getters.getToken) {
          let jwt = new VueEasyJwt();

          if (
            config.data &&
            typeof config.data === 'object' &&
            config.data.get('grant_type') == 'refresh_token'
          ) {
            store.commit('incCounterLoader');
            return config;
          }

          if (jwt.isExpired(store.getters.getToken.access_token)) {
            await store.dispatch('refreshToken', Vue.prototype);
          }

          var dataToken = store.getters.getToken;

          if (dataToken && dataToken.token_type && dataToken.access_token) {
            config.headers.Authorization = `${dataToken.token_type}  ${dataToken.access_token}`;
            config.headers['Content-Type'] = 'application/json';

            store.commit('incCounterLoader');
            return config;
          }
        }
        config.headers['Content-Type'] = 'application/json';

        store.commit('incCounterLoader');
        return config;
      },
      (error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
        } else {
          // Something happened in setting up the request that triggered an Error
        }
        // Retorna a promisse rejeitada
        return Promise.reject(error);
      }
    );

    //Cria o interceptor de requisição
    Vue.prototype.$http.interceptors.response.use(
      (response) => {
        store.commit('setLoader', false);
        store.commit('decCounterLoader');
        return response;
      },
      (error) => {
        store.commit('setLoader', false);
        store.commit('decCounterLoader');
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // exibirErroTratado(error, Vue.prototype, 'error', null)

          exibirErroTratado(error, Vue.prototype, 'error', null);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          exibirErroTratado(error, Vue.prototype, 'error', null);
        } else {
          // Something happened in setting up the request that triggered an Error
        }
        // Retorna a promisse rejeitada
        return Promise.reject(error);
      }
    );
  },
});

// Consome o verbo GET do protocolo HTTP do serviço da API
export const obterDados = (urlResource, vm) => {
  return new Promise((resolve, reject) => {
    // Consome o serviço
    axios
      .get(`${baseApiUrl}/${urlResource}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          vm.$toast.add({
            severity: 'error',
            summary: 'Erro ao processar requisição, recurso não encontrado',
            life: 3000,
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
        } else {
          // Something happened in setting up the request that triggered an Error
        }

        reject(error);
      });
  });
};

// Consome o verbo POST do protocolo HTTP do serviço da API
export const criarDados = (urlResource, dadosRecurso, vm) => {
  return new Promise((resolve, reject) => {
    // Consome o serviço
    axios
      .post(`${baseApiUrl}/${urlResource}`, JSON.stringify(dadosRecurso))
      .then((res) => {
        resolve(res.data);
      })
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          vm.$toast.add({
            severity: 'error',
            summary: 'Erro ao processar requisição, recurso não encontrado',
            life: 3000,
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
        } else {
          // Something happened in setting up the request that triggered an Error
        }

        reject(error);
      });
  });
};

export default { obterDados, criarDados };
